import { Form } from "react-bootstrap";
import "../App.css";

export default function CustomSwitch({
  checked,
  onChange,
  disabled = false,
  className = "",
  ...rest
}) {
  return (
    <Form.Check
      type="switch"
      checked={Boolean(checked)}
      disabled={disabled}
      onChange={onChange}
      className={`custom-switch ${className}`}
      {...rest}
    />
  );
}